module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=reviewTVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div ng-include=\"'header-course'\"></div> <div ng-include=\"'courses-list'\"></div> <div ng-include=\"'course-details-modal'\"></div> </div> </md-dialog-content> </md-dialog> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/partials/review/modals/addConsolidationOfferCourses.html
// module id = 710
// module chunks = 0